import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import { Menu99Food } from "../entities/stores/menu99food";
import StoreDB from "./store";

class Menu99FoodDB extends FirestorePipe {
    public static readonly colName = "MenuDelivery";

    constructor(idEstab: string, idStore: string) {
        if (!idEstab)
            throw new Error('Informe o id do estabelecimento')
        if (!idStore)
            throw new Error('Informe o id do store')
        super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${Menu99FoodDB.colName}`);
    }

    public async create(data: Menu99Food): Promise<any> {
        throw new Error('Method not exists')
    }
    public async define(id: string, data: Menu99Food): Promise<any> {
        return this._define(id, data);
    }
    public async update(id: string, data: Menu99Food): Promise<any> {
        return this._update(id, data);
    }
    public delete(id: string): Promise<any> {
        throw new Error('Method not exists')
    }
    public getAll(...params: QueryConstraint[]): Promise<Menu99Food[]> {
        return this._getAll<any>(...params);
    }
    public get(id: string): Promise<any> {
        return this._get(id);
    }
    public on(listener: (data: any[]) => void, ...params: QueryConstraint[]): Unsubscribe {
        return this._on(listener, ...params);
    }

}

export default Menu99FoodDB;
